import { Dispatch, ThunkAction } from '../../../../../../../../../types/actions';
import { IGetState, TBoardId } from '../../../../../../../../../types/types';
import { webhooksDelete } from '../../../../../../../../../rest/effects/webhooks/webhooksDelete';

export const onDelete = (
    boardId: TBoardId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState,
    ) => {
        return dispatch(webhooksDelete(boardId));
    };
    return action;
};
